/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_d29312af{overflow:auto}\n"}]);
export const root = "root_d29312af";